import React from "react";
import { NavLink } from "react-router-dom";

const FlutterHero = () => {
    return (
        <>
            <section className="flutter-hero">

                <div className="flutter-grid"></div>

                <div className="container">

                    <div className="flutter-left">

                        <span className="flutter-badge">
                            🚀 Flutter App Development
                        </span>

                        <h1>
                            Build Beautiful
                            <br />
                            <span>Flutter Apps</span>
                        </h1>

                        <p>
                            Create stunning cross-platform applications with Flutter.
                            One codebase, native performance, beautiful UI and faster
                            development for Android, iOS and Web.
                        </p>

                        <div className="flutter-buttons">
                            <NavLink
                                to="/Contactus"
                                className="primary-btn"
                            >
                                Start Project →
                            </NavLink>
                        </div>

                        <div className="flutter-stats">

                            <div>
                                <h3>100+</h3>
                                <span>Apps Delivered</span>
                            </div>

                            <div>
                                <h3>98%</h3>
                                <span>Client Satisfaction</span>
                            </div>

                            <div>
                                <h3>4.9★</h3>
                                <span>Store Ratings</span>
                            </div>

                        </div>

                    </div>

                    <div className="flutter-right">

                        <div className="flutter-phone">

                            <div className="flutter-screen">

                                <div className="flutter-header">

                                    <div className="flutter-mini-card">
                                        💙 Flutter
                                    </div>

                                    <h2>
                                        Fast.
                                        <br />
                                        Flexible.
                                        <br />
                                        Beautiful.
                                    </h2>

                                </div>

                                <div className="feature-card">
                                    <div className="icon">⚡</div>
                                    <div>
                                        <h4>Native Performance</h4>
                                        <p>Fast & Smooth Apps</p>
                                    </div>
                                </div>

                                <div className="feature-card">
                                    <div className="icon">📱</div>
                                    <div>
                                        <h4>Cross Platform</h4>
                                        <p>Android & iOS</p>
                                    </div>
                                </div>

                                <div className="feature-card">
                                    <div className="icon">🎨</div>
                                    <div>
                                        <h4>Beautiful UI</h4>
                                        <p>Pixel Perfect Design</p>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="floating-card">
                            <div className="circle">
                                💙
                            </div>

                            <div>
                                <h4>Flutter 3.0</h4>
                                <p>Powered by Google</p>
                            </div>
                        </div>

                        <div className="performance-card">
                            <h3>60 FPS</h3>
                            <span>Smooth Performance</span>
                        </div>

                    </div>

                </div>
                <style>
                    {`.flutter-hero{
    position:relative;
    overflow:hidden;
    padding:130px 20px 100px;
    background:linear-gradient(
        180deg,
        #ffffff 0%,
        #f4fbff 50%,
        #ffffff 100%
    );
}

.flutter-grid{
    position:absolute;
    inset:0;

    background-image:
        linear-gradient(rgba(0,0,0,.04) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0,0,0,.04) 1px, transparent 1px);

    background-size:70px 70px;
    opacity:.8;
}

.flutter-hero .container{
    max-width:1400px;
    margin:auto;
    display:grid;
    grid-template-columns:1.1fr .9fr;
    gap:80px;
    align-items:center;
    position:relative;
    z-index:2;
}

/* LEFT */

.flutter-badge{
    display:inline-flex;
    align-items:center;
    gap:10px;
    padding:12px 22px;
    border-radius:999px;
    background:rgba(4,117,255,.08);
    border:1px solid rgba(4,117,255,.15);
    color:#E8212A;
    font-size:13px;
    font-weight:700;
    margin-bottom:30px;
    font-family:'Plus Jakarta Sans',sans-serif;
}

.flutter-left h1{
    font-family:'Syne',sans-serif;
    font-size:clamp(42px,5vw,72px);
    line-height:1.05;
    font-weight:800;
    margin-bottom:20px;
    color:#111;
}

.flutter-left h1 span{
    color:#E8212A;
}

.flutter-left p{
    max-width:650px;
    font-size:18px;
    line-height:1.9;
    color:#666;
    margin-bottom:40px;
    font-family:'Plus Jakarta Sans',sans-serif;
}

.primary-btn{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    padding:18px 34px;
    border-radius:16px;
    background:linear-gradient(
        135deg,
        #E8212A,
        #FF4D4D
    );
    color:#fff;
    text-decoration:none;
    font-weight:700;
    transition:.3s;
    box-shadow:0 20px 50px rgba(4,117,255,.2);
}

.primary-btn:hover{
    transform:translateY(-5px);
}

.flutter-stats{
    display:flex;
    gap:50px;
    margin-top:50px;
    flex-wrap:wrap;
}

.flutter-stats h3{
    font-size:42px;
    margin:0;
    color:#E8212A;
    font-family:'Syne',sans-serif;
}

.flutter-stats span{
    color:#666;
    font-size:14px;
}

/* RIGHT */

.flutter-right{
    position:relative;
    height:750px;
}

.flutter-phone{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    width:340px;
    height:690px;
    padding:12px;
    border-radius:50px;
    background:#111;
    overflow:hidden;
    box-shadow:0 40px 100px rgba(4,117,255,.18);
}

.flutter-screen{
    width:100%;
    height:100%;
    border-radius:40px;
    overflow:hidden;
    background:linear-gradient(
        180deg,
        #FF4D4D,
        #E8212A
    );
    padding:28px;
}

.flutter-mini-card{
    display:inline-flex;
    align-items:center;
    gap:10px;
    padding:10px 16px;
    border-radius:14px;
    background:rgba(255,255,255,.15);
    border:1px solid rgba(255,255,255,.2);
    color:#fff;
    margin-bottom:25px;
}

.flutter-header h2{
    color:#fff;
    font-size:54px;
    line-height:.95;
    margin:0;
    font-family:'Syne',sans-serif;
}

/* FEATURE CARD */

.feature-card{
    display:flex;
    align-items:center;
    gap:15px;
    padding:18px;
    margin-top:20px;
    border-radius:24px;
    background:rgba(255,255,255,.15);
    backdrop-filter:blur(20px);
    border:1px solid rgba(255,255,255,.2);
}

.icon{
    width:58px;
    height:58px;
    border-radius:18px;
    background:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:24px;
}

.feature-card h4{
    color:#fff;
    margin:0 0 4px;
    font-size:18px;
    font-family:'Syne',sans-serif;
}

.feature-card p{
    margin:0;
    color:rgba(255,255,255,.8);
    font-size:13px;
}

/* FLOATING CARD */

.floating-card{
    position:absolute;
    top:80px;
    right:0;
    display:flex;
    align-items:center;
    gap:15px;
    background:#fff;
    padding:18px 22px;
    border-radius:24px;
    box-shadow:0 20px 60px rgba(0,0,0,.08);
}

.circle{
    width:55px;
    height:55px;
    border-radius:16px;
    display:flex;
    align-items:center;
    justify-content:center;
    background:linear-gradient(
        135deg,
        #E8212A,
        #FF4D4D
    );
    color:#fff;
    font-size:24px;
}

.floating-card h4{
    margin:0;
    color:#111;
    font-family:'Syne',sans-serif;
}

.floating-card p{
    margin:5px 0 0;
    color:#666;
    font-size:13px;
}

/* PERFORMANCE */

.performance-card{
    position:absolute;
    bottom:120px;
    left:0;
    background:#fff;
    padding:24px 28px;
    border-radius:24px;
    box-shadow:0 20px 60px rgba(0,0,0,.08);
}

.performance-card h3{
    margin:0;
    color:#E8212A;
    font-size:34px;
    font-family:'Syne',sans-serif;
}

.performance-card span{
    color:#666;
    font-size:13px;
}

/* MOBILE */

@media(max-width:991px){

    .flutter-hero .container{
        grid-template-columns:1fr;
    }

    .flutter-right{
        height:auto;
        margin-top:50px;
        display:flex;
        justify-content:center;
    }

    .flutter-phone{
        position:relative;
        top:auto;
        left:auto;
        transform:none;
    }

    .floating-card,
    .performance-card{
        display:none;
    }
}

@media(max-width:768px){

    .flutter-left h1{
        font-size:48px;
    }

    .flutter-phone{
        width:300px;
        height:600px;
    }

    .flutter-header h2{
        font-size:42px;
    }

    .flutter-stats{
        gap:25px;
    }

    .flutter-stats h3{
        font-size:30px;
    }
}`}
                </style>
            </section>
        </>
    );
};

export default FlutterHero;